import { render, staticRenderFns } from "./AfterList.vue?vue&type=template&id=162d596c&scoped=true&"
import script from "./AfterList.vue?vue&type=script&lang=js&"
export * from "./AfterList.vue?vue&type=script&lang=js&"
import style0 from "./AfterList.vue?vue&type=style&index=0&id=162d596c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d596c",
  null
  
)

export default component.exports